$(document).ready( function() {
  $(document).on('click', '#devise_sign_in_form', function(e){
    $('#devise_sign_in_form').val('SIGNING IN...');
    e.preventDefault();
    $.ajax({
      url: "/users/fhh45e3475c803dfg43ae5a0edfhr506369ca4e",
      type: "POST",
      dataType: 'json',
      data: { 
        user: { 
          email: $('input#email').val(),
          password: $('input#password').val()
        }
      },
      beforeSend: function(xhr) {
        xhr.setRequestHeader('X-CSRF-Token', $('meta[name="csrf-token"]').attr('content'))
      },
      success: function(msg){
        window.location.replace('/admin/members');
      },
      error: function(msg) {
        $('#devise_sign_in_form').val('SIGN IN');
        $('#devise_error_message').empty().append(JSON.parse(msg['responseText']).error);
      }
    })
  })
})